import React from 'react';
import { clsx } from 'clsx';
import { Filter } from 'lucide-react';

interface ProductFiltersProps {
  activeCategory: string;
  onSelectCategory: (category: string) => void;
  className?: string;
  isMobile?: boolean;
  onOpenSizeGuide?: () => void;
}

const CATEGORIES = ['Todos', 'Ciudad', 'Trabajo', 'Carretera', 'Trayectos Cortos', 'Viajes Largos', 'Off-Road'];

export const ProductFilters: React.FC<ProductFiltersProps> = ({ 
  activeCategory, 
  onSelectCategory,
  className,
  isMobile = false,
  onOpenSizeGuide
}) => {
  if (isMobile) {
    return (
      <div className={clsx("flex overflow-x-auto gap-3 py-4 px-4 bg-[#061970] sticky top-[68px] z-40 no-scrollbar border-b border-[#459EDF]/20", className)}>
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => onSelectCategory(cat)}
            className={clsx(
              "whitespace-nowrap px-6 py-2 rounded-full font-bold uppercase text-sm transition-all italic",
              activeCategory === cat 
                ? "bg-[#FF7F32] text-white shadow-[0_0_15px_rgba(255,127,50,0.5)]" 
                : "bg-white/10 text-white/70 hover:bg-white/20"
            )}
          >
            {cat}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={clsx("w-64 flex-shrink-0 p-6 bg-white border-r border-gray-100 min-h-[calc(100vh-80px)]", className)}>
      <div className="flex items-center gap-2 mb-6 text-[#061970]">
        <Filter className="w-5 h-5" />
        <h3 className="font-black italic text-xl uppercase">Filtros</h3>
      </div>
      
      <div className="space-y-2">
        <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-4">Uso</h4>
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => onSelectCategory(cat)}
            className={clsx(
              "w-full text-left px-4 py-3 rounded-lg font-bold transition-all uppercase italic text-sm flex justify-between items-center group",
              activeCategory === cat 
                ? "bg-[#061970] text-white skew-x-[-6deg]" 
                : "text-gray-600 hover:bg-gray-50"
            )}
          >
            <span className={clsx(activeCategory === cat ? "skew-x-[6deg]" : "")}>{cat}</span>
            {activeCategory === cat && <div className="w-2 h-2 bg-[#FF7F32] rounded-full skew-x-[6deg]" />}
          </button>
        ))}
      </div>

      <div className="mt-10 p-4 bg-[#459EDF]/10 rounded-xl border border-[#459EDF]/30">
        <h4 className="font-bold text-[#061970] mb-2 text-sm">¿Necesitas ayuda?</h4>
        <p className="text-xs text-gray-600 mb-3">Deja que Max te ayude a elegir tu casco ideal.</p>
        <button 
          onClick={onOpenSizeGuide}
          className="text-[#FF7F32] font-bold text-xs uppercase underline hover:text-[#e66a20] transition-colors"
        >
          Ver Guía de Tallas
        </button>
      </div>
    </div>
  );
};
